<template>
  <v-container>
    <v-layout row wrap>
      <!--  <v-flex xs12 md4> -->
      <!-- <v-select
          name="broker"
          v-bind:label="$t('message.broker')"
          v-validate="'required'"
          :error-messages="errors.collect('broker')"
          single-line
          :items="broker"
          v-model="e3Broker"
      ></v-select>-->
      <!-- 
        <v-autocomplete
          :items="broker"
          :filter="customFilter"
          color="white"
          item-text="Descripcion"
          item-value="IdApsSos"
          name="broker"
          v-bind:label="$t('message.aps')"
          v-validate="'required'"
          :error-messages="errors.collect('broker')"
          v-model="e3Broker"
      ></v-autocomplete>-->
      <!--  </v-flex> -->
      <v-flex xs12 md6>
        <v-select name="yearCommercial" v-bind:label="$t('message.yearCommercial')" v-validate="'required'"
          :error-messages="errors.collect('yearCommercial')" item-text="Valor" :items="yearCommercial"
          v-model="e6yearCommercial"></v-select>
      </v-flex>

      <v-flex xs12 md6>
        <v-select name="indicator" v-bind:label="$t('message.indicator')" v-validate="'required'"
          :error-messages="errors.collect('indicator')" item-text="value" item-value="code" :items="catalogIndicators"
          v-model="e1Indicator"></v-select>
      </v-flex>

      <v-flex xs12 md6>
        <v-select name="startWeek" v-bind:label="$t('message.startWeek')" v-validate="'required'"
          :error-messages="errors.collect('startWeek')" item-text="Valor" :items="startWeek"
          v-model="e4startWeek"></v-select>
      </v-flex>

      <v-flex xs12 md6>
        <v-select name="endWeek" v-bind:label="$t('message.endWeek')" v-validate="'required'"
          :error-messages="errors.collect('endWeek')" item-text="Valor" :items="endWeek" v-model="e5endWeek"></v-select>
      </v-flex>

      <v-flex xs12 md6>
        <v-text-field name="percent" v-bind:label="$t('message.percent')" v-validate="'required'"
          :error-messages="errors.collect('percent')" type="number" min="0" max="100" @keyup="checkMax($event, 100)"
          v-model="percentPareto" pattern="\d*"></v-text-field>
      </v-flex>

      <v-flex xs12 md6 class="radioPadding" style="padding-top:34px">
        <!--   <v-select
          name="branchOffices"
          v-bind:label="$t('message.branchOffices')"
          v-validate="'required'"
          :error-messages="errors.collect('branchOffices')"
          item-text="NombreAgencia"
          item-value="IdAgencia"
          :items="branchOffices"
          v-model="e2BranchOffices"
        ></v-select>-->
        <label style="color: rgb(149, 149, 149);!important;font-size: 16px;
              line-height: 1;
              min-height: 8px;font-weight: 400;">Sucursales</label>
        <v-radio-group name="branchOffices" v-validate="'required'" :error-messages="errors.collect('branchOffices')"
          v-model="branchOffices" :mandatory="false">
          <v-radio label="Todas" value="0"></v-radio>
          <v-radio label="Sucursal Actual" value="1"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <!-- <v-flex class="row text-lg-center">
      <v-chip
        color="primary"
        text-color="white"
      >{{headerChips[0].Nombre}}: $ {{headerChips[0].Valor}}</v-chip>
      <v-chip
        color="primary"
        text-color="white"
      >{{headerChips[1].Nombre}}: $ {{headerChips[1].Valor}}</v-chip>
      <v-chip
        color="primary"
        text-color="white"
      >{{headerChips[2].Nombre}}: $ {{headerChips[2].Valor}}</v-chip>
      <v-chip
        color="primary"
        text-color="white"
      >{{headerChips[3].Nombre}}: {{headerChips[3].Valor}} %</v-chip>
      <v-chip
        color="primary"
        text-color="white"
      >{{headerChips[4].Nombre}}: $ {{headerChips[4].Valor}}</v-chip>
      <v-chip
        color="primary"
        text-color="white"
      >{{headerChips[5].Nombre}}: {{headerChips[5].Valor}} %</v-chip>
    </v-flex>-->
    <!-- <v-layout row wrap>
      <v-flex class="md8 lg8" offset-md2 offset-lg2>
        <chart-weekly-budget-compliance
          :data="dataFromGraphic"
          :labels="labels"
          :xAxes="xAxes"
          :yAxes="yAxes"
          :annotation="annotation"
        ></chart-weekly-budget-compliance>
      </v-flex>
    </v-layout>-->
    <!-- <v-layout row wrap>
      <v-flex md8 lg8>
        <chart-pareto
          :data="dataChartPareto"
          :backgroundColor="backgroundColorChartPareto"
          :labels="labelsChartPareto"
        ></chart-pareto>
      </v-flex>
      <v-flex md4 lg4 d-block>
        <h3 class="subheading text--secondary">{{$t('message.statistics')}}</h3>
        <v-data-table
          flat
          hide-actions
          item-key="id"
          :items="statistics"
          :headers="headerStatistics"
          class="v-table-list v-table-list-last-tr theme--light"
          :rows-per-page-text="$t('message.rowsByPage')"
        >
          <template slot="items" scope="props">
            <tr :active="props.selected" @click="props.selected = !props.selected">
              <td class="text-xs-left cut-text">{{ props.item.businessYearIncome }}</td>
              <td class="text-xs-left cut-text">{{ props.item.value }}</td>
            </tr>
          </template>
          <template slot="no-data">
            <div>{{$t('message.noRecords')}}</div>
          </template>
          <template
            slot="pageText"
            slot-scope="props"
          >{{ props.pageStart }} - {{ props.pageStop }} {{$t('message.of')}} {{ props.itemsLength }}</template>
        </v-data-table>
      </v-flex>
    </v-layout>-->
    <v-flex class="row pt-4">
      <h3 class="subheading text--secondary">{{ $t('message.listFirtClients') }} {{ lengthFisrtClients }}
        {{ $t('message.clients') }}</h3>
      <v-layout>
        <v-flex text-lg-left>
          <v-btn class="ml-0" flat icon color="primary" v-on:click="refresh">
            <v-icon>cached</v-icon>
          </v-btn>
        </v-flex>
        <v-flex text-lg-right>
          <v-text-field v-model="searchTable1" append-icon="search" label="Buscar" single-line
            hide-details></v-text-field>
        </v-flex>
      </v-layout>
      <v-data-table :items="table1" :headers="headerSectionFirstClients" class="v-table-list theme--light"
        :search="searchTable1">
        <template slot="items" scope="props">
          <tr :active="props.selected" @click="props.selected = !props.selected">
            <td class="text-xs-left cut-text">{{ props.index + 1 }}</td>
            <td class="text-xs-left cut-text">{{ props.item.Nombre }}</td>
            <td class="text-xs-left cut-text">{{ props.item.Valor }}$</td>
            <td class="text-xs-left cut-text">{{ props.item.Porcentaje }}%</td>
          </tr>
        </template>
        <template slot="no-data">
          <div>{{ $t('message.noRecords') }}</div>
        </template>
        <template slot="pageText" slot-scope="props">{{ props.pageStart }} - {{ props.pageStop }} {{ $t('message.of') }}
          {{ props.itemsLength }}</template>
      </v-data-table>
    </v-flex>
    <v-flex class="row">
      <h3 class="subheading text--secondary">{{ $t('message.listLastClients') }} {{ lengthLastClients }}
        {{ $t('message.clients') }}</h3>
      <v-layout>
        <v-flex text-lg-left>
          <v-btn class="ml-0" flat icon color="primary" v-on:click="refresh">
            <v-icon>cached</v-icon>
          </v-btn>
        </v-flex>
        <v-flex text-lg-right>
          <v-text-field v-model="searchTable2" append-icon="search" label="Buscar" single-line
            hide-details></v-text-field>
        </v-flex>
      </v-layout>
      <v-data-table :items="table2" :headers="headersSectionLastClients" class="v-table-list theme--light"
        :search="searchTable2">
        <template slot="items" scope="props">
          <tr :active="props.selected" @click="props.selected = !props.selected">
            <td class="text-xs-left cut-text">{{ props.index + 1 }}</td>
            <td class="text-xs-left cut-text">{{ props.item.Nombre }}</td>
            <td class="text-xs-left cut-text">$ {{ props.item.Valor }}</td>
            <td class="text-xs-left cut-text">{{ props.item.Porcentaje }}%</td>
          </tr>
        </template>
        <template slot="no-data">
          <div>{{ $t('message.noRecords') }}</div>
        </template>
        <template slot="pageText" slot-scope="props">{{ props.pageStart }} - {{ props.pageStop }} {{ $t('message.of') }}
          {{ props.itemsLength }}</template>
      </v-data-table>
    </v-flex>
  </v-container>
</template>


<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import router from "@/router";

import DatePicker from "@/components/DatePicker/DatePicker";

import ChartPareto from "./ChartPareto.vue";
import ChartWeeklyBudgetCompliance from "./ChartWeeklyBudgetCompliance.vue";

import { EventBus } from "@/imports/EventBus";

import CatalogServices from "@/services/CatalogsServices";

import CommercialGraphicsServices from "@/services/CommercialGraphicsServices";

export default {
  components: {
    ChartPareto,
    ChartWeeklyBudgetCompliance,
    DatePicker
  },
  beforeDestroy() {
    EventBus.$off("Pareto");
  },
  computed: {
    ...mapGetters(["agency", "userProfile", "agencyId"])
  },
  mounted() {


    EventBus.$on("Pareto", () => {
      console.log("activa")
      this.$validator.validateAll().then(success => {
        if (success) {
          this.$nextTick(() => {
            this.getDataFromApi();
          });
          /* this.showGraphic=true
            this.table1=analysisJSONTest.Data.Tabla1
          */
        }
      });
    });
    this.getCatalogInfo();
  },
  methods: {
    checkMax(e, max) {
      if (parseInt(e.target.value) > max) {
        var str = e.target.value;
        str = str.slice(0, -1);
        this.percentPareto = str;
      }
      if (parseInt(e.target.value) < 0) {
        var str = e.target.value;
        str = str.substr(1);
        this.percentPareto = str;
      }
      if (e.target.value.indexOf(".") > -1) {
        var str = e.target.value;
        str = str.slice(0, -1);
        this.percentPareto = str;
      }
    },
    customFilter(item, queryText, itemText) {
      if (item.Descripcion != null && item.IdApsSos != null) {
        const textOne = item.Descripcion.toLowerCase();
        const textTwo = item.IdApsSos.toLowerCase();
        const searchText = queryText.toLowerCase();

        return (
          textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
        );
      }
    },
    nzDate: nzDate,
    getCatalogInfo() {
      /* ComunServices.getAgencies()
        .then(response => {
          this.branchOffices= response.data.data.Data;
        })
        .catch(res => {
          this.$root.$emit(
            "showSnackBar",
            "No se ha podido cargar las sucursales",
            "error"
          );
        });
      ComunServices.getAgents()
        .then(response => {
          this.broker = response.data.data.Data;
        })
        .catch(res => {
          this.$root.$emit(
            "showSnackBar",
            "No se ha podido cargar APS",
            "error"
          );
        }); */
      CatalogServices.getIndicators()
        .then(response => {
          this.catalogIndicators = response.data.data;
        })
        .catch(res => {
          this.$root.$emit("showSnackBar", "Error desconocido", "error");
        });
    },
    refresh() {
      this.$validator.validateAll().then(success => {
        if (success) {
          this.$nextTick(() => {
            this.table1 = [];
            this.table2 = [];
            (this.lengthFisrtClients = ""),
              (this.lengthLastClients = ""),
              this.getDataFromApi();
          });
        }
      });
    },
    getDataFromApi() {
      this.table1 = [];
      this.table2 = [];
      this.lengthFisrtClients = "";
      this.lengthLastClients = "";
      this.$root.$emit(
        "showLoading",
        "Cargando cumplimiento semanal de presupuesto"
      );
      let agencyId = "";
      if (this.branchOffices == "1") {
        agencyId = this.agencyId;
      } else {
        agencyId = 0;
      }
      this.e3Broker = this.userProfile.id_aps_vt;
      CommercialGraphicsServices.getParetoGraphic(
        this.e3Broker,
        this.e6yearCommercial,
        this.e4startWeek,
        this.e5endWeek,
        this.e1Indicator,
        agencyId,
        this.percentPareto
        /* this.e2BranchOfficesBudget */
      ).then(res => {
        let dataResponse = res.data.data.Data;
        if (
          typeof res.data.data.Error != undefined &&
          res.data.data.Data == null
        ) {
          this.$root.$emit("hideLoading");
          this.$root.$emit("showSnackBar", res.data.data.Msg, "error");
        }

        if (
          res.data.data.Data.Tabla1.length == 0 &&
          res.data.data.Data.Tabla2.length == 0
        ) {
          this.$root.$emit("hideLoading");
          this.$root.$emit(
            "showSnackBar",
            "No hay datos que mostrar",
            "accent"
          );
        } else if (typeof dataResponse != "undefined") {
          this.table1 = res.data.data.Data.Tabla1;
          this.table2 = res.data.data.Data.Tabla2;
          if (this.table1.length > 0) {
            this.lengthFisrtClients = this.table1.length;
          }
          this.lengthLastClients = this.table2.length;
          this.setFormatTable(this.table1, {});
          this.setFormatTable(this.table2, {});
          this.$root.$emit("hideLoading");
        }
      });
      /*  this.headerChips = paretoJSONTest.Data.Cabecera;
      this.formatHeadersChips(paretoJSONTest.Data.Cabecera);
      this.dataFromGraphic = [
        {
          label: paretoJSONTest.Data.Grafico[0].Label,
          yAxisID: "A",
          borderColor: "#FC2525",
          pointBackgroundColor: "white",
          borderWidth: 1,
          pointBorderColor: "#FC2525",
          backgroundColor: "transparent",
          data: paretoJSONTest.Data.Grafico[0].Data
        },
        {
          label: paretoJSONTest.Data.Grafico[1].Label,
          yAxisID: "B",
          borderColor: "#05CBE1",
          pointBackgroundColor: "white",
          pointBorderColor: "#05CBE1",
          borderWidth: 1,
          backgroundColor: "transparent",
          data: paretoJSONTest.Data.Grafico[1].Data
        }
      ];
      //this.labels = paretoJSONTest.Data.Grafico[0].Data;
      //this.labels = paretoJSONTest.Data.Grafico[0].Data;
      this.yAxes = [
        {
          id: "A",
          type: "linear",
          position: "right"
        },
        {
          id: "B",
          type: "linear",
          position: "left",
          ticks: {
            callback: function(value, index, values) {
              return value + " %";
            },
            max: 125,
            min: 0
          }
        }
      ];
      this.setRangeLabels(paretoJSONTest.Data.Tabla1.length);
      this.annotation = {
        annotations: [
          {
            type: "line",
            mode: "horizontal",
            scaleID: "y-axis-0",
            value: 5,
            borderColor: "rgb(75, 192, 192)",
            borderWidth: 4,
            label: {
              enabled: false,
              content: "Test label"
            }
          }
        ]
      };
 */
      /* this.$set(this.statistics,paretoJSONTest.Data.Grafico2[0].Label,paretoJSONTest.Data.Grafico2[0].Data)
      this.$set(this.statistics,paretoJSONTest.Data.Grafico2[1].Label,paretoJSONTest.Data.Grafico2[1].Data)
    */
      /*  this.setDataStatistics(paretoJSONTest.Data.Grafico2); */
      /*  this.backgroundColorChartPareto = [
        "rgba(65, 184, 131, .8)",
        "rgba(228, 102, 81, .8)"
      ]; */
      /* this.labels = paretoJSONTest.Data.Grafico[2].Data;
      this.xAxes = paretoJSONTest.Data.Grafico[2].Label;
      this.yAxes = "Valores";

      this.table1 = paretoJSONTest.Data.Tabla1;
      this.table2 = paretoJSONTest.Data.Tabla2;

      let restrictsTable2 = { Semana: "Semana" };
      this.setFormatTable(this.table1, {});
      this.setFormatTable(this.table2, restrictsTable2);
      this.yAxes = [
        {
          ticks: {
            callback: function(value, index, values) {
              return value.toLocaleString();
            }
          },
          scaleLabel: {
            display: true,
            labelString: this.yAxes
          }
        }
      ]; */
      /* axios
        .get("/")
        .then(function(response) {
          // handle success
        })
        .catch(function(error) {
          // handle error
        }); */
    },
    setDataStatistics(table) {
      let total = 0;
      table.forEach(element => {
        let obj = {
          businessYearIncome: element.Label,
          value: element.Data.toLocaleString()
        };
        this.statistics.push(obj);
        this.labelsChartPareto.push(element.Label);
        this.dataChartPareto.push(Number(element.Data));
        total += Number(element.Data);
      });
      let obj = { businessYearIncome: "Total", value: total.toLocaleString() };
      this.statistics.push(obj);
    },
    setRangeLabels(range) {
      for (let i = 0; i < range; i++) {
        this.labels[i] = i;
      }
    },
    setFormatNumber(num, symbol) {
      let separator = ".";
      let sepDecimal = ",";
      num += "";
      var splitStr = num.split(".");
      var splitLeft = splitStr[0];
      var splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : "";
      var regx = /(\d+)(\d{3})/;
      while (regx.test(splitLeft)) {
        splitLeft = splitLeft.replace(regx, "$1" + separator + "$2");
      }
      return symbol + splitLeft + splitRight;
    },

    setFormatTable(table, restricts) {
      let cont = 0;
      table.forEach(element => {
        for (var property in element) {
          if (property != " " && typeof restricts[property] == "undefined") {
            let str = element[property];
            str = str.replace(",", ".");
            str = this.setFormatNumber(str, "");
            table[cont][property] = str;
          }
        }
        cont++;
      });
    },
    setCharAt(str, index, chr) {
      if (index > str.length - 1) return str;
      return str.substr(0, index) + chr + str.substr(index + 1);
    },
    formatHeadersChips(headers) {
      let cont = 0;
      headers.forEach(element => {
        for (var property in element) {
          if (property != "") {
            let str = element[property];
            str = str.replace(",", ".");
            str = this.setFormatNumber(str, "");
            this.headerChips[cont][property] = str;
          }
        }
        cont++;
      });
    }
  },
  watch: {},
  data() {
    return {
      lengthFisrtClients: "",
      lengthLastClients: "",
      searchTable1: "",
      searchTable2: "",
      catalogIndicators: [],
      dataChartPareto: [],
      backgroundColorChartPareto: [],
      labelsChartPareto: [],
      annotation: [],
      yAxes: [{}],
      xAxes: [],
      labels: [],
      dataFromGraphic: [],
      headerChips: [],
      dataFromApi: {},
      table1: [],
      table2: [],
      e3Broker: null,
      broker: [],
      selected: [],
      pagination: {},
      yearCommercial: [
        "2012",
        "2013",
        "2014",
        "2015",
        "2016",
        "2017",
        "2018",
        "2019",
        "2020",
        "2021",
        "2022",
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
        "2031",
        "2032",
        "2033",
        "2034",
        "2035",
        "2036",
        "2037",
        "2038",
        "2039",
        "2040",
        "2041",
        "2042",
        "2043",
        "2044",
        "2045",
        "2046",
        "2047",
        "2048",
        "2049",
        "2050"
      ],
      e1Indicator: null,
      e2BranchOffices: null,
      e4startWeek: null,
      e5endWeek: null,

      e6yearCommercial: null,
      typeProduction: [],
      branchOffices: "",
      startWeek: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "51",
        "52"
      ],
      endWeek: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "51",
        "52"
      ],
      indicator: "",
      percentPareto: "",

      statistics: [
        /*  { businessYearIncome: "Primeros 977 clientes", value: "$2724" },
        { businessYearIncome: "Ultimos 1227 clientes", value: "$224" },
        { businessYearIncome: "Total", value: "$2948" } */
      ],
      searchValue: "",
      headerSectionFirstClients: [
        {
          align: "left",
          sortable: false,
          text: i18n.t("#"),
          value: "index",
          width: "5%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.clientName"),
          value: "Nombre",
          width: "25%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.value"),
          value: "Valor",
          width: "25%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.percent"),
          value: "Porcentaje",
          width: "25%"
        }
      ],
      headersSectionLastClients: [
        {
          align: "left",
          sortable: false,
          text: i18n.t("#"),
          value: "index",
          width: "5%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.clientName"),
          value: "Nombre",
          width: "25%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.value"),
          value: "Valor",
          width: "25%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.percent"),
          value: "Porcentaje",
          width: "25%"
        }
      ]
    };
  }
};
</script>
<style>
@media only screen and (max-width: 600px) {
  .radioPadding {
    padding-top: 0px !important;
  }
}
</style>